var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"expressionBarsAxisTop",attrs:{"id":"expressionBarsAxisTop"}}),_c('v-card',{staticClass:"expressionBarsChart",attrs:{"id":"expressionBarsChart","flat":""}}),_c('div',{staticClass:"expressionBarsAxisBottom",attrs:{"id":"expressionBarsAxisBottom"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }